<template>
  <v-container>
    <v-row justify="center">
      <v-col
        cols="12"
        sm="9"
      >
        <v-card>
          <v-card-title>
            Request Company
          </v-card-title>
          <v-form ref="form">
            <v-card-text>
              This request form will notify FPS admin of the need to add a new company. When the new company
              is added to our system we will let you know and you will be able to search for it and create a job link with it.
              <v-row>
                <v-col
                  cols="12"
                >
                  <v-text-field
                    v-model="company.name"
                    label="Name*"
                    :rules="[rules.required]"
                  />
                </v-col>
                <v-col
                  cols="12"
                >
                  <v-text-field
                    v-model="company.phone"
                    label="Phone*"
                    :rules="[rules.required]"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="12"
                  class="py-0"
                >
                  <h4>Address </h4>
                </v-col>
                <v-col
                  cols="12"
                >
                  <v-text-field
                    v-model="company.address.streetName"
                    label="Street Name*"
                    :rules="[rules.required]"
                  />
                </v-col>
                <v-col
                  cols="12"
                >
                  <v-text-field
                    v-model="company.address.streetName2"
                    label="Street Name (2)"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="company.address.city"
                    label="City*"
                    :rules="[rules.required]"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="2"
                >
                  <v-text-field
                    v-model="company.address.state"
                    v-mask="masks.stateAbbrv"
                    label="State*"
                    :rules="[rules.required]"
                    data-cy="company-text-personal-state"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    v-model="company.address.zipCode"
                    label="Zip Code*"
                    :rules="[rules.required]"
                  />
                </v-col>
                <v-col cols="12">
                  <v-select
                        v-model="company.taxClassification"
                        :items="[
                          'Sole Proprietor',
                          'Corporation',
                          'Limited Liability Company',
                          'General Partnership'
                        ]"
                        label="Tax Classification"
                        data-cy="request-company-form-select-pay-day"
                      />
                </v-col>
                <v-col cols="12">
                  <v-row>
                    <v-col cols="12" sm="6">
                      <v-select
                        v-model="company.payDay"
                        :items="[
                          'Monday',
                          'Tuesday',
                          'Wednesday',
                          'Thursday',
                          'Friday',
                          'Saturday',
                          'Sunday',
                        ]"
                        label="Pay Day"
                        data-cy="request-company-form-select-pay-day"
                      />
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-select
                        v-model="company.payDayFrequency"
                        :items="payDayFrequencyOptions"
                        label="Pay Day Frequency"
                        data-cy="request-company-form-select-pay-day-frequency"
                      />
                    </v-col>
                    <v-col v-if="payDayFrequency === 'Other'" cols="12" md="3">
                      <v-text-field
                        v-model="company.payDayFrequencyOther"
                        label="Pay Day Frequency"
                        data-cy="request-company-form-text-price"
                      />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row justify="end">
                <v-col cols="auto">
                  <v-btn
                    text
                    outlined
                    :to="{name: 'jobs'}"
                  >
                    cancel
                  </v-btn>
                </v-col>
                <v-col
                  cols="auto"
                >
                  <v-btn
                    color="primary"
                    @click="submit"
                  >
                    Submit
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import masks from '../utils/masks';
import { requestCompany, getUser } from '../services/users';

export default {
  components: {
  },
  data() {
    return {
      rules: {
          required: value => !!value || 'Required.',
      },
      company: {
        email: '',
        name: '',
        phone: '',
        address: {},

        payDayFrequency: "",
        payDayFrequencyOther: "",
        taxClassification: "",
      },
      payDayFrequencyOptions: ["Weekly", "Biweekly", "Other"],
      zipCode: '',
      masks,

    };
  },
  async mounted() {
    let current_user = await getUser();
    this.company['email'] = current_user['data']['email'];
  },
  methods: {
    async submit() {
      if (!this.$refs.form.validate()) {
        this.scrollToFirstFormError();
        return;
      }
      this.submitButtonIsLoading = true;
      const company = JSON.parse(JSON.stringify(this.company));
      try {
        await requestCompany(company);
        this.$router.push({ name: 'request-company-success' });
      } catch (e) {
        if (e.response.status === 502) {
          this.$emit('snackbar', { text: '502 Bad Gateway', color: 'red' });
        } else {
          this.$emit('snackbar', { text: 'Error Submitting Forms', color: 'red' });
        }
      }
    },
    scrollToFirstFormError() {
      let firstInvalidInput;
      this.$refs.form.inputs.some((input) => {
        if (!input.valid) {
          firstInvalidInput = input;
        }
        return !input.valid;
      });
      if (firstInvalidInput) {
        this.$vuetify.goTo(firstInvalidInput.$el);
      }
    },
  },
};
</script>